import { render, staticRenderFns } from "./RightSideLogin.vue?vue&type=template&id=0beb4f1c&scoped=true"
import script from "./RightSideLogin.vue?vue&type=script&lang=js"
export * from "./RightSideLogin.vue?vue&type=script&lang=js"
import style0 from "./RightSideLogin.vue?vue&type=style&index=0&id=0beb4f1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0beb4f1c",
  null
  
)

export default component.exports